/**
 * sanitizeStorefrontUrl -- allowlist a distributor-authored URL to a safe
 * anchor href, or null.
 *
 * SECURITY (open-redirect / javascript: injection): the hero carousel's
 * click_through_url is distributor-authored and craftable directly via the
 * API. Only an http(s) URL or a same-site relative path ("/...", not the
 * protocol-relative "//host") may become an anchor href; anything else
 * (javascript:, data:, mailto:, a whitespace/case-obfuscated scheme) is
 * dropped to null so the slide renders as a plain, non-clickable image.
 *
 * Extracted so the P5 Home page (via useStorefrontChrome) and the legacy
 * StorefrontViewShopper hero apply IDENTICAL rules -- this is the single
 * source for the click-through allowlist. Behavior is verbatim from
 * StorefrontViewShopper.sanitizeClickThroughUrl.
 *
 * @param {*} raw distributor-authored URL (any type; non-strings drop to null)
 * @returns {string|null} safe href, or null when disallowed
 */
export function sanitizeStorefrontUrl(raw) {
    if (!raw || typeof raw !== 'string') {
        return null
    }
    const trimmed = raw.trim()
    if (trimmed === '') {
        return null
    }
    // Relative path (no scheme) is allowed: starts with "/" and is NOT a
    // protocol-relative "//host" URL (which could redirect off-site).
    if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
        return trimmed
    }
    try {
        // Resolve against the current origin so scheme detection is robust
        // (handles whitespace/case tricks like "JavaScript:").
        const origin =
            typeof window !== 'undefined' && window.location
                ? window.location.origin
                : 'http://localhost'
        const parsed = new URL(trimmed, origin)
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
            return trimmed
        }
    } catch (e) {
        return null
    }
    return null
}

export default sanitizeStorefrontUrl
